import React from 'react';
import {TouchableOpacity, Text, StyleSheet, View} from 'react-native';
import {useTranslation} from 'react-i18next';

interface ScanButtonProps {
  onPress: () => void;
  disabled?: boolean;
}

// De grote knop waar je op moet drukken om foto's te maken
const ScanButton: React.FC<ScanButtonProps> = ({onPress, disabled = false}) => {
  const {t} = useTranslation();

  return (
    <TouchableOpacity
      style={[stijlen.container, disabled && stijlen.disabled]}
      onPress={onPress}
      disabled={disabled}>
      <View style={stijlen.iconContainer}>
        <Text style={stijlen.icon}>📷</Text>
      </View>
      <Text style={stijlen.label}>{t('home.scanButton') || 'Scan'}</Text>
    </TouchableOpacity>
  );
};

const stijlen = StyleSheet.create({
  container: {
    width: 140,
    height: 140,
    borderRadius: 70,
    backgroundColor: '#4A90E2',
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6,
    elevation: 8,
  },
  disabled: {
    backgroundColor: '#CCC',
    opacity: 0.6,
  },
  iconContainer: {
    marginBottom: 8,
  },
  icon: {
    fontSize: 48,
  },
  label: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#FFFFFF',
    textAlign: 'center',
  },
});

export default ScanButton;
